/**
 * easy.MARKETING · emid capture
 * Reads the emid click identifier from the URL (?emid=…) and persists it as a
 * Shopify cart attribute, so it reaches the order-confirmation page reliably
 * (readable there as checkout.attributes.emid) even when the thank-you page does
 * not share browser storage with the storefront.
 */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var urlEmid = params.get('emid');
    if (urlEmid && urlEmid.length === 24) {
      window.localStorage.setItem('emid', urlEmid);
    }

    var emid = window.localStorage.getItem('emid');
    if (!emid) return;

    // Sync once per session per value to avoid redundant cart writes.
    if (window.sessionStorage.getItem('emid_synced') === emid) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { emid: emid } }),
    })
      .then(function () {
        window.sessionStorage.setItem('emid_synced', emid);
      })
      .catch(function () {});
  } catch (e) {}
})();
